import React from 'react';

import { motion, type MotionStyle } from 'framer-motion';
import isEmpty from 'lodash/isEmpty';
import { Link, useParams } from 'react-router-dom';

import { type ArtifactType } from '@app/client/common/structs/nft/artifacts';
import { useLocationQuery } from '@app/helpers';
import { PathParams } from '@app/routes/types';
import { artifactKeyToUrlMap, artifactUrlToKeyMap } from '@app/store/types/artifacts';

import './ArtifactTile.scss';

interface ArtifactTileProps {
    type: ArtifactType;
    children: React.ReactNode;
}

const tileTransition = {
    type: 'spring',
    damping: 80,
    stiffness: 300,
    mass: 5,
    restDelta: 0.00001,
};

function getTileStyle(expanded): MotionStyle {
    if (expanded) {
        return {
            position: 'fixed',
            top: '0vh',
            left: '0vh',
            height: '100vh',
            width: '100vw',
            zIndex: 3,
            margin: 0,
        };
    } else {
        return {
            position: 'relative',
            zIndex: 1,
        };
    }
}

export function ArtifactTile({ type, children }: ArtifactTileProps) {
    const query = useLocationQuery();
    const { [PathParams.ArtifactType]: artifactType } = useParams();
    const currentArtifactType = artifactUrlToKeyMap.get(artifactType as ArtifactType);
    const expanded = !isEmpty(query.get('expanded')) && currentArtifactType === type;

    return (
        <motion.div
            className="yat-artifacts-tile"
            style={getTileStyle(expanded)}
            transition={{ ...tileTransition, delay: expanded ? 0 : 0.175 }}
            initial={{
                borderRadius: 7,
            }}
            animate={{
                borderRadius: expanded ? 0 : undefined,
                zIndex: !expanded ? 1 : 4, // tim if you see this i need help here pls :'(
            }}
            layout
        >
            {children}
            {!expanded && (
                <Link to={`/artifacts/${artifactKeyToUrlMap.get(type)}?expanded=true`}>
                    <div className="yat-artifacts__slider__slide__expand" />
                </Link>
            )}
        </motion.div>
    );
}
